import "./startup-loading.css";

import { Spinner } from "@/design-system/Spinner";

/** Declares that a root boundary is pending. The persistent indicator avoids restarting its delay between stages. */
export function StartupLoading(): React.ReactNode {
  return <div className="min-h-screen w-full" data-app-pending data-testid="startup-loading" />;
}

/** One visual indicator for consecutive root loading stages, derived from the rendered pending markers without shared state. */
export function ApplicationLoadingIndicator(): React.ReactNode {
  return (
    <div
      data-application-loading-indicator
      className="pointer-events-none fixed inset-0 z-50 items-center justify-center"
    >
      <Spinner size="3xl" />
    </div>
  );
}
